export default class RoleNames {
    public static readonly SysAdmin: string = 'sysadmin';
    public static readonly User: string = 'user';

    public static readonly CustomerUser: string = 'customer_user';
    public static readonly Administrator: string = 'administrator';
    /** Holds a maintainer seat: may edit people, teams, job roles and tags. */
    public static readonly Maintainer: string = 'maintainer';
    public static readonly TechnicalContact: string = 'technical_contact';
    public static readonly BillingProcurement: string = 'billing_procurement';
    public static readonly SupportContact: string = 'support_contact';

    /** Who may manage the directory: people, job roles and tags. */
    public static readonly DirectoryEditors: string[] = [
        RoleNames.Administrator,
        RoleNames.Maintainer
    ];

    public static readonly BaseRoles: string[] = [
        RoleNames.SysAdmin,
        RoleNames.User
    ];
}
